<template>
    <v-table class="tabela-customizada">
        <thead>
            <tr>
                <th class="esquerda coluna-menor">TAG</th>
                <th>DESCRIÇÃO AUTOMAÇÃO</th>
                <th class="coluna-menor">TAXA DE GRAVAÇÃO</th>
                <th>DESCRIÇÃO PLATAFORMA</th>
                <th class="coluna-menor">VALOR</th>
                <th>UNIDADE</th>
                <th class="direita">AÇÃO</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in dados" :key="item.id">
                <td>{{ item.tag }}</td>
                <td>{{ item.descricaoAutomacao }}</td>
                <td>{{ item.taxaGravacao }}</td>
                <td :class="itemEditando === item.id ? 'no-padding' : ''">
                    <v-text-field v-if="itemEditando === item.id"
                        v-model="valoresEditados.descricaoPlataforma"></v-text-field>
                    <span class="texto" v-else>{{ item.descricaoPlataforma }}</span>
                </td>
                <td>{{ item.valor }}</td>
                <td :class="itemEditando === item.id ? 'no-padding' : ''">
                    <v-select v-if="itemEditando === item.id" v-model="valoresEditados.unidade"
                        :items="item.opcoesUnidade"></v-select>
                    <span class="texto" v-else>{{ item.unidade }}</span>
                </td>
                <td>
                    <div class="d-flex justify-center gap-10">
                        <button class="editar" @click="editarItem(item)"></button>
                        <button v-if="itemEditando === item.id" class="salvar" @click="salvarEdicao(item.id)"></button>
                    </div>
                </td>
            </tr>
        </tbody>
    </v-table>
    <div class="lista-mobile">
        <v-card class="card-variavel" v-for="item in dados" :key="item.id">
            <v-card-item>
                <div class="container-conteudo">
                    <v-row>
                        <v-col class="linha-conteudo" cols="6">
                            <span>TAG:</span>
                            <span class="bold">{{ item.tag }}</span>
                        </v-col>
                        <v-col class="linha-conteudo" cols="6">
                            <span>Taxa de gravação:</span>
                            <span class="bold">{{ item.taxaGravacao }}</span>
                        </v-col>
                        <v-col class="linha-conteudo" cols="12">
                            <span>Descrição da Automação:</span>
                            <span class="bold">{{ item.descricaoAutomacao }}</span>
                        </v-col>
                        <v-col class="linha-conteudo" cols="12">
                            <span>Descrição da plataforma:</span>
                            <v-text-field class="input-list" v-if="itemEditando === item.id"
                                v-model="valoresEditados.descricaoPlataforma"></v-text-field>
                            <span class="bold" v-else>{{ item.descricaoPlataforma }}</span>
                        </v-col>
                        <v-col class="linha-conteudo" cols="6">
                            <span>Valor:</span>
                            <span class="bold">{{ item.valor }}</span>
                        </v-col>
                        <v-col class="linha-conteudo" cols="6">
                            <span>Unidade:</span>
                            <v-select class="select-list" v-if="itemEditando === item.id"
                                v-model="valoresEditados.unidade" :items="item.opcoesUnidade"></v-select>
                            <span class="bold" v-else>{{ item.unidade }}</span>
                        </v-col>
                        <v-col cols="12">
                            <div class="d-flex justify-end gap-10">
                                <button class="editar" @click="editarItem(item)"></button>
                                <button class="salvar" @click="salvarEdicao(item.id)"
                                    v-if="itemEditando === item.id"></button>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card-item>
        </v-card>
    </div>
</template>

<script>
import { useRoute } from "vue-router";
import { ref, watch, onMounted } from "vue";
import { eventBus } from "./core/EventBus";
import axios from "axios";
import { toRaw } from 'vue';

export default {
    props: {
        registro: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    setup() {
        const route = useRoute();
        const equipamentoId = ref(route.params.id);
        const dados = ref([]);
        const itemEditando = ref(null);
        const valoresEditados = ref({});

        const carregarDados = async () => {
            try {
                const response = await axios.get(`https://infinity-refrisat.com/equipamento/${equipamentoId.value}/variaveis`);
                dados.value = response.data.variaveis;
                eventBus.emit("mudou-nome-equipamento", response.data.nomeEquipamento);
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
            }
        };

        const editarItem = (item) => {
            itemEditando.value = item.id;
            valoresEditados.value = { ...item };
        };

        const salvarEdicao = async (id) => {
            const rawValoresEditados = toRaw(valoresEditados.value);
            const response = await axios.put(`https://infinity-refrisat.com/equipamento/variaveis/${id}`, rawValoresEditados);
            itemEditando.value = null;
            valoresEditados.value = null;
            const index = dados.value.findIndex((item) => item.id === id);
            if (index !== -1) {
                dados.value[index] = response.data
            }
        };

        onMounted(() => {
            carregarDados();
        });

        watch(() => route.params.id, (newId) => {
            equipamentoId.value = newId;
            carregarDados();
        });

        return {
            dados,
            editarItem,
            salvarEdicao,
            itemEditando,
            valoresEditados
        };
    },
};
</script>

<style scoped>
.lista-mobile {
    display: none;
}

.tabela-customizada {
    background-color: var(--bg-color);
    color: var(--text-color);
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;

    thead {
        tr {
            background-color: var(--bg-color);

            th {
                color: var(--text-color) !important;
                text-align: center !important;
                background: var(--table-color);
                border-top: 1px solid #6C6C6C;
                border-bottom: 1px solid #6C6C6C !important;
                border-left: 0px;
                border-right: 0px;
            }

            th.esquerda {
                border-radius: 5px 0px 0px 5px;
                border-left: 1px solid #6C6C6C;
            }

            th.direita {
                border-radius: 0px 5px 5px 0px;
                border-right: 1px solid #6C6C6C;
            }
        }
    }

    tbody {
        tr {
            background-color: var(--bg-color);

            td {
                border-bottom: 0px !important;
                border: 5px solid var(--bg-color);
                background: var(--table-color);
                border-radius: 15px;
                max-width: 300px;
            }

            td:first-child {
                border-left: 0px;
            }

            td:last-child {
                border-right: 0px;
            }
        }
    }

    ::v-deep(.v-field) {
        border-radius: 10px;
    }

    ::v-deep(.v-field__outline) {
        margin-left: 6px;
        width: 95%;
        color: var(--text-color);
    }

    ::v-deep(.v-select) {
        ::v-deep(.v-field__outline) {
            width: 90% !important;
        }
    }

    .no-padding {
        padding: unset !important;
    }

    .texto {
        word-break: break-word;
    }

    .coluna-menor {
        width: 10px;
    }
}


.editar {
    background: url('../assets/lapis.svg') no-repeat center center;
    width: 27px;
    height: 27px;
    border: none;
    cursor: pointer;
}

.salvar {
    background: url('../assets/check.svg') no-repeat center center;
    width: 27px;
    height: 27px;
    border: none;
    cursor: pointer;
}

::v-deep(.v-input__details) {
    display: none !important;
}

@media (max-width: 960px) {
    .tabela-customizada {
        display: none;
    }

    .lista-mobile {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: center;
        gap: 15px;
        width: 100%;
    }

    .card-variavel {
        width: 90%;
        box-shadow: 5px 8px 8px rgba(0, 0, 0, 0.1);
        margin: 8px;
        background-color: var(--card-color) !important;
        color: var(--text-color);
        font-size: 16px;
        line-height: 18.75px;
    }

    .container-conteudo {
        padding: 5px;
    }

    .linha-conteudo {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: flex-start;
        gap: 5px;

        span {
            text-align: start;
        }
    }

    .input-list {
        width: 100%;
    }

    .select-list {
        width: 100%;
    }
}
</style>
